import { ConvertedImageRaw } from '../../types';

import { ChallengeSaveError } from '../../../types';

import { createCoreMethod } from '../../utils/createCoreMethod';
import { getImageForNode } from '../../utils/getImageForNode';
import { isNodeWithSize } from '../../utils/isNodeWithSize';
import { shallowFindInContainer } from '../../utils/shallowFind';
import { isNodeWithChildren } from '../../utils/isNodeWithChildren';

/**
 * nodeContentOnly - determining whether other layers overlapping with node will be exported (or partially exported)
 */
export const getReviewNodeImage = createCoreMethod(
  'getReviewNodeImage',
  async (
    nodeId: string,
    parentNodeId = undefined,
    nodeContentOnly = false,
    scale = 1,
    hide = false
  ): Promise<ConvertedImageRaw | ChallengeSaveError> => {
    await figma.currentPage.loadAsync();
    let parentNode: BaseNode | null = figma.currentPage;

    if (parentNodeId) {
      parentNode = shallowFindInContainer(parentNodeId, figma.currentPage);

      if (!parentNode) {
        parentNode = figma.currentPage.findOne((n) => n.id === parentNodeId);
      }
    }

    if (!parentNode) {
      parentNode = figma.currentPage;
    }

    // @TODO - check if parent is valid there
    if (!parentNode || !isNodeWithChildren(parentNode)) {
      return { type: 'NODE_NOT_FOUND' };
    }

    let node: BaseNode | null = shallowFindInContainer(nodeId, parentNode);

    if (!node) {
      node = parentNode.findOne((n) => n.id === nodeId);
    }

    // last chance to find the node outside of the parent
    if (!node) {
      parentNode = figma.currentPage;
      node = parentNode.findOne((n) => n.id === nodeId);
    }

    if (!node || !isNodeWithSize(node)) {
      return { type: 'NODE_NOT_FOUND' };
    }

    // verify with simulations
    if (node.height / node.width > 10)
      return { type: 'IMAGE_TOO_BIG', nodeId: node.id, nodeName: node.name };

    try {
      if (hide && 'opacity' in node) node.opacity = 0;
      const result = await getImageForNode(node, nodeContentOnly, scale);
      if (hide && 'opacity' in node) node.opacity = 1;

      if ('converted' in result) {
        return {
          converted: result.converted.take(),
        };
      }

      return result;
    } catch {
      return { type: 'NODE_NOT_FOUND', nodeId: node.id, nodeName: node.name };
    }
  }
);
